// extracted by mini-css-extract-plugin
export default {"mainBox":"Auth_mainBox__1yFYC","logoBox":"Auth_logoBox__FB239"};